export const CURRENCY_SIGNS = {
  eur: '€',
  usd: '$',
  chf: '₣',
}

export const EURO_CURRENCY_KEY = 'eur'
export const DOLLAR_CURRENCY_KEY = 'usd'
export const DEFAULT_CURRENCY = EURO_CURRENCY_KEY
